export default __webpack_public_path__ + "static/media/citroen.0f554417.svg";